// eslint-disable-next-line no-unused-vars
import BiodataRepository from '../../../domain/repositories/BiodataRepository';

class GetBiodataProfilesUseCase {
    /**
     * @param {BiodataRepository} biodataRepository
     */
    constructor(biodataRepository) {
        this.biodataRepository = biodataRepository;
    }

    /**
     * @returns {Promise<Biodata[]>}
     */
    async execute() {
        return this.biodataRepository.getBiodataProfiles();
    }
}

export default GetBiodataProfilesUseCase;
